<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";

export default {
  page: {
    title: "Grupe",
  },
  components: {PageHeader, Layout},
  props: {
  },
  data() {
    return {
      title: 'Grupe',
      fields: [
        {key: 'name', label: 'Naziv', sortable: false},
        {key: 'types', label: 'Vrste', sortable: false},
        {key: 'budget', label: 'Budžet', sortable: false},
      ],
      groups: [],
      search: ''
    }
  },
  async created() {
    this.$store.commit('loader/START_LOADING');
    try {
      const {data} = await axios.get(`/admin/groups/`);
      this.groups = data;
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  computed: {
    searchedGroups () {
      return this.groups.filter((g) => {
        return g.name?.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  methods: {
    showGroup(group) {
      this.$router.push(`/admin/groups/${group.id}/edit`)
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="search-box chat-search-box mb-2">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <b-table :items="searchedGroups" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
                 selectable
                 @row-clicked="showGroup"
        >
          <template v-slot:cell(types)="data">
            {{ data.value.map(t => t.name).join(", ") }}              
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  .autocomplete {
    width: 100%;
  }
</style>
